import * as yup from 'yup';

export const PedidoProdutoSchema = yup.object().shape({
  quantidade: yup.number().required('Campo Obrigatório!'),
  value: yup.string().required('Campo Obrigatório!'),
  grupo_tributario: yup.string().required('Campo Obrigatório!'),
});
